import moment from 'moment'
import 'moment/min/locales.min'
import 'number-to-locale-string'
import * as React from 'react'
import { render } from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import Login from './login/Login'
import ErrorBoundary from './ErrorBoundary'
import LoggedOutModal from './LoggedOutModal'
import MaintenancePage from './MaintenancePage'
import Signup from './advertiser_signup/SignupContainer'
import LoadIndicator from './common/LoadIndicator'
import { getUserLanguage } from './common/languageMapping'
import { UserProvider } from './context/UserProvider'
import UserSignup from './invite_signup/main'
import PasswordRecovery from './password_recovery/main'
moment.locale(getUserLanguage())

import { SWRConfig, SWRConfiguration } from 'swr'
import { Fetcher } from 'swr/dist/types'

import ExternalAdApproval from './external/ExternalAdApproval/ExternalAdApproval'
import ExternalSiteList from './external/externalSiteList/ExternalSiteList'

import apiFetch from './common/apiFetch'
import OauthLoginForm from './oauthLogin/OauthLoginForm'
import OauthPermission from './oauthLogin/OauthPermission'
import { captureExceptionWithSentry, initSentry } from './sentry'

initSentry()

const swrconfig: SWRConfiguration<any, any, Fetcher<any>> = {
	fetcher: (input: RequestInfo, init: RequestInit = {}) => {
		// A hack to make SWR support ReadpeakAPI
		if (typeof input === 'string' && !input.startsWith('/api/')) {
			return apiFetch(input, init)
				.then((res) => res.json())
				.catch(captureExceptionWithSentry)
		}
		// By default we send credentials over as that is by far the most common case
		return fetch(input, { credentials: 'same-origin', ...init })
			.then((res) => res.json())
			.catch(captureExceptionWithSentry)
	},
}

const App = React.lazy(() =>
	import(
		/* webpackChunkName: "app" */
		'./App'
	),
)
const MainMenu = React.lazy(() =>
	import(
		/* webpackChunkName: "main-menu" */
		'./MainMenu'
	),
)

const Root = () => {
	return (
		<ErrorBoundary>
			<SWRConfig value={swrconfig}>
				<BrowserRouter>
					<Switch>
						<Route path="/signup" exact render={(props) => <Signup language="en" {...props} />} />
						<Route path="/rekisteroidy" exact render={(props) => <Signup language="fi" {...props} />} />
						<Route path="/signup/:token" render={(props) => <Signup language="en" {...props} />} />
						<Route path="/rekisteroidy/:token" render={(props) => <Signup language="fi" {...props} />} />
						<Route
							path="/embed/rekisteroidy"
							render={(props) => <Signup language="fi" embed={true} {...props} />}
						/>
						<Route
							path="/embed/signup"
							render={(props) => <Signup language="en" embed={true} {...props} />}
						/>
						<Route path="/users/signup" component={UserSignup} />
						<Route path="/users/passwordRecovery" component={PasswordRecovery} />
						<Route path="/login" component={Login} />
						<Route path="/oauth/login" component={OauthLoginForm} />
						<Route path="/oauth/permission" component={OauthPermission} />
						<Route
							path="/external/ad_approval/:token"
							render={(props) => <ExternalAdApproval {...props} />}
						/>
						<Route
							path="/external/sites/:country/:hash"
							render={({ match }) => (
								<ExternalSiteList country={match.params.country} hash={match.params.hash} />
							)}
						/>
						<Route
							render={() => (
								<UserProvider>
									<LoggedOutModal>
										<MaintenancePage>
											<React.Suspense fallback={<LoadIndicator />}>
												<MainMenu />
												<App />
											</React.Suspense>
										</MaintenancePage>
									</LoggedOutModal>
								</UserProvider>
							)}
						/>
					</Switch>
				</BrowserRouter>
			</SWRConfig>
		</ErrorBoundary>
	)
}
render(<Root />, document.querySelector('#root'))
